import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type {
  DefaultSupplierAllocation,
  FeasibilitySupplierBreakdown,
  RateCards,
  SupplierAllocation,
  SupplierBlend,
  SupplierBlendSave,
  SupplierGroupTemplate,
  SupplierManagedAllocationsUpdate,
  Survey,
} from '@ps/survey-utils';
import type { SuppliersMetaData } from '@ps/survey-creation-data-access';

/**
 * A global override CPI an Apply also carries to the project's other children
 * (the open survey's own PUT already holds it).
 */
export interface OfferPriceToChildren {
  readonly surveyIds: readonly number[];
  readonly offerPrice: number;
}

export const ManageSupplierActions = createActionGroup({
  source: 'Manage Supplier',
  events: {
    Load: props<{ surveyId: number; isChild: boolean }>(),
    'Update Managed Allocations': props<{
      surveyId: number;
      update: SupplierManagedAllocationsUpdate;
      offerPriceToChildren?: OfferPriceToChildren;
    }>(),
    'Save Blend': props<{ data: SupplierBlendSave }>(),
    'Reload Blends': props<{ locale: string }>(),
    Reset: emptyProps(),
  },
});

export const ManageSupplierApiActions = createActionGroup({
  source: 'Manage Supplier API',
  events: {
    // One aggregate success — the drawer opens only when everything (feasibility
    // included) is ready, so a single landing is simpler than granular ones.
    'Load Success': props<{
      survey: Survey;
      allocations: SupplierAllocation[];
      feasibilitySuppliers: readonly FeasibilitySupplierBreakdown[];
      blends: SupplierBlend[];
      groupTemplates: SupplierGroupTemplate[];
      defaultAllocations: DefaultSupplierAllocation[];
      rateCards: RateCards | null;
      suppliersMetaData: SuppliersMetaData;
    }>(),
    'Load Failure': props<{ error: string }>(),
    'Update Allocations Success': props<{
      allocations: SupplierAllocation[];
      blendId: string;
    }>(),
    'Update Allocations Failure': props<{ error: string }>(),
    'Save Blend Success': props<{ blend: SupplierBlend }>(),
    'Save Blend Failure': props<{ error: string }>(),
    'Reload Blends Success': props<{ blends: SupplierBlend[] }>(),
  },
});
